import { render, staticRenderFns } from "./BardistPVP.vue?vue&type=template&id=ed964ce2"
import script from "./BardistPVP.vue?vue&type=script&lang=js"
export * from "./BardistPVP.vue?vue&type=script&lang=js"
import style0 from "./BardistPVP.vue?vue&type=style&index=0&id=ed964ce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports